export const DEFAULT_SURVEY_EXPLANATION_MESSAGES = Object.freeze({
  ANONYMOUS: {
    en: 'The following is an anonymous survey question. Neither your name nor number will be included with your response.\n\n',
    es: 'La siguiente encuesta es anónima. Su nombre y número no se adjuntarán a su respuesta.\n\n',
  },
  ANONYMOUS_UI: 'Recipients will be notified that this survey is anonymous',
  NON_ANONYMOUS: {
    en: '\n\n(Your name and number will be included with your response)',
    es: '\n\n(Su nombre y número se adjuntarán a su respuesta)',
  },
  NON_ANONYMOUS_UI:
    'Recipients will be notified that their name and number will be shared with their response',
  PRE_SURVEYS: `Hi there - This is the employee survey number for {{{ job.companyName }}}. You&apos;ll receive texts from time to time asking for your thoughts. Thank you for taking the time to share!
                \n\nSome surveys will be marked “anonymous.” These will not display your name or number with your response in order to create a safe space to share your thoughts and opinions.
                \n\nOther surveys may not be anonymous. We automatically receive your name and number with your response so that we can follow up if helpful.`,
});
